import { useMemo } from "react";
import { useGetAllNotesQuery, useGetAllPersonsQuery, EventTypes } from "@/services/api";
import type { Dayjs } from "dayjs";
import { checkAnniversaryDate } from "../utils";

export const useCalendarEventItem = (id: string, type: EventTypes, currentDate: Dayjs) => {
  const { data: notes } = useGetAllNotesQuery();
  const { data: persons } = useGetAllPersonsQuery();

  const person = useMemo(() => {
    return type === EventTypes.BIRTHDAY
      ? persons?.persons.find((record) => record.id === id)
      : null;
  }, [id, type]);

  const note = useMemo(() => {
    if (type === EventTypes.NOTE) {
      const _note = notes?.find((record) => record.id === id);
      const _person = persons?.persons.find((record) => record.id === _note?.personId);

      return {
        person: _person,
        note: _note,
      };
    }
  }, [id, type]);

  const anniversary = useMemo(() => {
    if (type === EventTypes.ANNIVERSARY) {
      const _person = persons?.persons.find((record) => record.id === id);

      return _person
        ? {
            ..._person,
            anniversaries: _person.anniversaries.filter((_anniversary) => {
              return checkAnniversaryDate(currentDate, _anniversary.anniversarySDate);
            }),
          }
        : null;
    }
    return null;
  }, [id, type]);

  return {
    person,
    note,
    anniversary,
  };
};
